import { Outlet } from 'react-router-dom';

import { MethodType } from '@endeavour/payment-integration';

import { CashierContext } from '../containers/cashier-context/cashier-context';
import { DepositPage } from '../containers/deposit-page/deposit-page';
import { Details } from '../containers/details/details';
import { ResponsePage } from '../containers/response-page/response-page';
import { WithdrawalPage } from '../containers/withdrawal-page/withdrawal-page';

export default [
    {
        path: '*',
        element: (
            <CashierContext>
                <Outlet />
            </CashierContext>
        ),
        children: [
            {
                path: 'deposit',
                element: <DepositPage />,
            },
            {
                path: 'deposit/:integrationId/:method',
                element: <Details methodType={MethodType.DEPOSIT} />,
            },
            {
                path: 'deposit/:integrationId/:method/:accountId',
                element: <Details methodType={MethodType.DEPOSIT} />,
            },
            {
                path: 'withdrawal',
                element: <WithdrawalPage />,
            },
            {
                path: 'withdrawal/:integrationId/:method',
                element: <Details methodType={MethodType.WITHDRAWAL} />,
            },
            {
                path: 'withdrawal/:integrationId/:method/:accountId',
                element: <Details methodType={MethodType.WITHDRAWAL} />,
            },
        ],
    },
    {
        path: 'deposit/complete/:transactionId',
        element: <ResponsePage methodType={MethodType.DEPOSIT} />,
    },
    {
        path: 'withdrawal/complete/:transactionId',
        element: <ResponsePage methodType={MethodType.WITHDRAWAL} />,
    },
];
